
$(document).ready(function(){

    $('.custom-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      draggable: true,
      autoplay: true,
      autoplaySpeed: 7000,
      fade: true,
      speed: 500,
      cssEase: 'ease-in-out',
      touchThreshold: 100,
      prevArrow: '<div class="slick-prev"><i class="fas fa-long-arrow-alt-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fas fa-long-arrow-alt-right"></i></div>'
    });

    $('.blog__posts').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      draggable: true,
      autoplay: true,
      speed: 800,
      prevArrow: '<div class="slick-prev"><i class="fas fa-long-arrow-alt-left"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fas fa-long-arrow-alt-right"></i></div>',
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    //Range quantity fabric

    var slider = $('#myRange');
    var sliderVal = slider.val();
    var quantitybox = $('.quantity__input');
    $('#fablength').html(sliderVal);
    quantitybox.html(sliderVal*2);

    slider.change(
      function updateValue(e) {
        newVal = e.target.value;
        price = $('#totalprice').data('price');
        newPrice = (newVal*price*2).toFixed(2);
        $('#fablength').html(newVal);
        $('#totalprice').html(newPrice);
        quantitybox.val(newVal*2);
      }
    );
  
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('signup') == 'success') {
    $('#shopify-section-announcement-bar').after('<div class="announcement-bar success gradient" role="region" aria-label="Announcement"><p class="announcement-bar__message h5">Thank you for creating an account with Sewing Gem.</p></div>') 
  }
})

$(window).on('load', function(){
  $('.loading').fadeOut("fast");
});

var COUNT = {
  init: function() {
    COUNT.register_events();
  },
  register_events: function() {
    
    $(document).on('cart:updated', COUNT.on_form_updated);

  },
  on_form_updated: function(){
    
    console.log('get cart');
    
    $.getJSON('/cart.js').then(
      function(cart){
        
        console.log('cart.js');
        
        var bar = $('.topbar');
        var txtPromote = bar.data("promote");
        var txtUnlocked = bar.data("unlocked");
        var threshold = bar.data("threshold");
        var value_left = (parseInt(threshold) - (cart.total_price/100)).toFixed(2);
        if(value_left > 0 ){
          
          bar.html( txtPromote.replace('[value]', '$' + value_left + ' AUD') );
          
        }else{
          
          bar.html(txtUnlocked);
          
        }
      }
    )
    
  }
};

$(COUNT.init);


var CART = {

  init: function(e) {
  //e.preventDefault();
	CART.register_events();
  },
  
  register_events: function() {

    $('body').on('submit', 'form[action*="/cart/add"]', CART.on_form_submit);

  },
  
  on_cart_updated: function() {
    
    $.getJSON('/cart.js').then(function(cart){
            $('.cart-count-bubble span').text( cart.item_count );

    });

  
  },
  
  on_form_submit: function(e) {

    e.preventDefault();
    var $this = $(this);
    
    var $qty = $this.find('input[name="quantity"]');
    
    if( $qty.length == 0 ) {
    
      $qty = $('input[name="quantity"]');
    
    }
    
    CART.add_product( $this.find('input[name="id"]').val(), $qty.val()).then(function() {
      
      document.dispatchEvent( new CustomEvent('cart:updated') );
      
      $('input[name="quantity"]').val(1);
      
      CART.on_cart_updated();
      
    });
  
  },
  
  add_product: function(id, qty) {
    
    qty = parseInt(qty);
    var line_items = [];
    
    for(var i = 0; i < qty; i++) {
    
      line_items.push({
        id: id,
        quantity: 1

      });
    
    }
    
    return $.ajax({
      
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      data: { items: line_items },
      
    });
  
  },

};

$(CART.init);
